/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  MockPriceProvidersRepository,
  MockPriceProvidersRepositoryInterface,
} from "../MockPriceProvidersRepository";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_quoteToken",
        type: "address",
      },
      {
        internalType: "address",
        name: "_factory",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [],
    name: "AssetNotSupported",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidPriceProvider",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidPriceProviderQuoteToken",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidRepository",
    type: "error",
  },
  {
    inputs: [],
    name: "ManagerDidNotChange",
    type: "error",
  },
  {
    inputs: [],
    name: "ManagerIsZero",
    type: "error",
  },
  {
    inputs: [],
    name: "OnlyManager",
    type: "error",
  },
  {
    inputs: [],
    name: "OnlyOwnerOrManager",
    type: "error",
  },
  {
    inputs: [],
    name: "OnlyRepository",
    type: "error",
  },
  {
    inputs: [],
    name: "PriceProviderAlreadyExists",
    type: "error",
  },
  {
    inputs: [],
    name: "PriceProviderDoesNotExist",
    type: "error",
  },
  {
    inputs: [],
    name: "PriceProviderNotRegistered",
    type: "error",
  },
  {
    inputs: [],
    name: "QuoteTokenNotSupported",
    type: "error",
  },
  {
    inputs: [],
    name: "TokenIsNotAContract",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "manager",
        type: "address",
      },
    ],
    name: "ManagerChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "contract IPriceProvider",
        name: "newPriceProvider",
        type: "address",
      },
    ],
    name: "NewPriceProvider",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "newPendingOwner",
        type: "address",
      },
    ],
    name: "OwnershipPending",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "asset",
        type: "address",
      },
      {
        indexed: true,
        internalType: "contract IPriceProvider",
        name: "priceProvider",
        type: "address",
      },
    ],
    name: "PriceProviderForAsset",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "contract IPriceProvider",
        name: "priceProvider",
        type: "address",
      },
    ],
    name: "PriceProviderRemoved",
    type: "event",
  },
  {
    inputs: [],
    name: "QUOTE_TOKEN_DECIMALS",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "acceptOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IPriceProvider",
        name: "_provider",
        type: "address",
      },
    ],
    name: "addPriceProvider",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_manager",
        type: "address",
      },
    ],
    name: "changeManager",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
    ],
    name: "getPrice",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IPriceProvider",
        name: "_provider",
        type: "address",
      },
    ],
    name: "isPriceProvider",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "manager",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "pendingOwner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "priceProviders",
    outputs: [
      {
        internalType: "contract IPriceProvider",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "priceProvidersRepositoryPing",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "prices",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "providerList",
    outputs: [
      {
        internalType: "address[]",
        name: "",
        type: "address[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "providersCount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
    ],
    name: "providersReadyForAsset",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "quoteToken",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "removePendingOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IPriceProvider",
        name: "_provider",
        type: "address",
      },
    ],
    name: "removePriceProvider",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_price",
        type: "uint256",
      },
    ],
    name: "setPrice",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "contract IPriceProvider",
        name: "_provider",
        type: "address",
      },
    ],
    name: "setPriceProviderForAsset",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "siloRepository",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newPendingOwner",
        type: "address",
      },
    ],
    name: "transferPendingOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

type MockPriceProvidersRepositoryConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: MockPriceProvidersRepositoryConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class MockPriceProvidersRepository__factory extends ContractFactory {
  constructor(...args: MockPriceProvidersRepositoryConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "MockPriceProvidersRepository";
  }

  deploy(
    _quoteToken: string,
    _factory: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<MockPriceProvidersRepository> {
    return super.deploy(
      _quoteToken,
      _factory,
      overrides || {}
    ) as Promise<MockPriceProvidersRepository>;
  }
  getDeployTransaction(
    _quoteToken: string,
    _factory: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(_quoteToken, _factory, overrides || {});
  }
  attach(address: string): MockPriceProvidersRepository {
    return super.attach(address) as MockPriceProvidersRepository;
  }
  connect(signer: Signer): MockPriceProvidersRepository__factory {
    return super.connect(signer) as MockPriceProvidersRepository__factory;
  }
  static readonly contractName: "MockPriceProvidersRepository";
  public readonly contractName: "MockPriceProvidersRepository";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): MockPriceProvidersRepositoryInterface {
    return new utils.Interface(_abi) as MockPriceProvidersRepositoryInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): MockPriceProvidersRepository {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as MockPriceProvidersRepository;
  }
}
